"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVisiblePrefsData = exports.getAdvancedPrefs = exports.getAllPrefsData = exports.excludedForViewOnly = void 0;
const data_1 = require("./data");
exports.excludedForViewOnly = [
    data_1.TXN_REG_PREF_FF.prefEditDownloaded,
    data_1.TXN_REG_PREF_FF.prefDeleteDownloaded,
    data_1.TXN_REG_PREF_FF.prefAutoSaveEditedTxns,
    data_1.TXN_REG_PREF_FF.prefNewTxnEntry,
];
const getAllPrefsData = (prefsData, hasWriteAccess) => prefsData.filter((pref) => {
    if (hasWriteAccess) {
        return true;
    }
    return !exports.excludedForViewOnly.includes(pref.fflag);
});
exports.getAllPrefsData = getAllPrefsData;
const getAdvancedPrefs = (prefsData, featureFlags) => (prefsData.filter((pref) => (pref.fflag && (featureFlags.get(pref.fflag) === 'advanced' || !featureFlags.get(pref.fflag)))));
exports.getAdvancedPrefs = getAdvancedPrefs;
const getVisiblePrefsData = (prefsData, featureFlags) => (prefsData.filter((pref) => (!pref.fflag || featureFlags.get(pref.fflag) === true || featureFlags.get(pref.fflag) === 'show')));
exports.getVisiblePrefsData = getVisiblePrefsData;
